import type { ComponentChildren, FunctionalComponent } from 'preact';

import { BubbleBody } from './__body/bubble__body.js';
import type { BubbleContentProps } from './__content/bubble__content.js';
import { BubbleContent } from './__content/bubble__content.js';
import { BubbleTail } from './__tail/bubble__tail.js';
import { cnBubble } from './bubble.constants.js';

import './bubble.css';

export interface BubbleProps extends BubbleContentProps {
    backgroundColor?: string;
    children: ComponentChildren;
    className?: string;
}

export const Bubble: FunctionalComponent<BubbleProps> = ({
    backgroundColor,
    children,
    className,
    tailHorizontalPosition,
    tailVerticalPosition,
}) => (
    <div className={cnBubble(null, className)}>
        <BubbleContent tailHorizontalPosition={tailHorizontalPosition} tailVerticalPosition={tailVerticalPosition}>
            <BubbleBody backgroundColor={backgroundColor}>{children}</BubbleBody>
            <BubbleTail
                color={backgroundColor}
                isFlippedVertically={tailVerticalPosition === 'top'}
                isFlippedHorizontally={tailHorizontalPosition === 'right'}
            />
        </BubbleContent>
    </div>
);
